import qs from 'querystring';
import axios from './customAxios';
/**
 * 报名
 *
 * @returns {Promise<ApiWrap<boolean>>} OK
 */

export function applyUsingPOST(params) {
  return axios.request({
    url: "/developer/apply",
    method: "post",
    data: qs.stringify(params)
  }).then(function (res) {
    return res.data;
  });
}
/**
 * 清除用户数据
 *
 * @returns {Promise<ApiWrap<boolean>>} OK
 */

export function clearUserDataUsingGET_1(params) {
  return axios.request({
    url: "/developer/clear-user-data",
    method: "get",
    params: params
  }).then(function (res) {
    return res.data;
  });
}
/**
 * 首页
 *
 * @returns {Promise<ApiWrap<DeveloperMeetingHomeVo>>} OK
 */

export function homeUsingGET_1(params) {
  return axios.request({
    url: "/developer/home",
    method: "get",
    params: params
  }).then(function (res) {
    return res.data;
  });
}
/**
 * 获取微信签名
 *
 * @returns {Promise<ApiWrap<WeCatSignatureVo>>} OK
 */

export function signatureUsingGET(params) {
  return axios.request({
    url: "/developer/signature",
    method: "get",
    params: params
  }).then(function (res) {
    return res.data;
  });
}
/**
 * 获取手机短信验证码
 *
 * @returns {Promise<ApiWrap<boolean>>} OK
 */

export function smsCodeUsingGET(params) {
  return axios.request({
    url: "/developer/sms-code",
    method: "get",
    params: params
  }).then(function (res) {
    return res.data;
  });
}